import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { MetricReportingPeriodType } from '~/types/types';
export default defineComponent({
  props: {
    metricAssignmentId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    metric: {
      type: Object,
      required: true
    },
    metricValues: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    inputs: {
      type: Array,
      required: true
    },
    skipped: {
      type: Boolean,
      default: false
    },
    clearTargets: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      required: false,
      default: ''
    },
    reportingPeriodType: {
      type: String,
      required: true
    },
    year: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup: function setup(props, context) {
    watch(function () {
      return props.metricValues;
    }, function (newValue) {
      return filteredMetricValues.value = filterForReportingPeriodTypeAndSort(newValue);
    });
    var createInputMap = function createInputMap(attribute) {
      // use metricValues as base and update with uncommitted data from inputs
      var inputMap = new Map();
      var toCheck = [].concat(_toConsumableArray(props.metricValues), _toConsumableArray(props.inputs));
      toCheck.forEach(function (e) {
        var key = "".concat(e.metricAssignmentId, "-").concat(e.period);
        var val = {
          metricAssignmentId: e.metricAssignmentId,
          period: e.period
        };
        val[attribute] = e[attribute];
        inputMap.set(key, val);
      });
      return inputMap;
    };
    watch(function () {
      return props.skipped;
    }, function (doSkip) {
      var inputMap = createInputMap('skipped');
      inputMap.forEach(function (val, key) {
        if (val.skipped === doSkip) {
          inputMap.delete(key); // no update necessary
        } else {
          val.skipped = doSkip;
          if (doSkip) {
            var toClear = {
              actual: null,
              text: null,
              options: null
            };
            val = _objectSpread(_objectSpread({}, val), toClear);
          }
          inputMap.set(key, val);
        }
      });
      onInput(Array.from(inputMap.values()));
    });
    watch(function () {
      return props.clearTargets;
    }, function (doClear) {
      if (!doClear) return;
      var inputMap = createInputMap('target');
      inputMap.forEach(function (val, key) {
        if (val.target === null) {
          inputMap.delete(key); // no update necessary
        } else {
          val = _objectSpread(_objectSpread({}, val), {}, {
            target: null
          });
          inputMap.set(key, val);
        }
      });
      onInput(Array.from(inputMap.values()));
    });
    var filterForReportingPeriodTypeAndSort = function filterForReportingPeriodTypeAndSort(metricValues) {
      var _metricValues$filter;
      return (metricValues === null || metricValues === void 0 ? void 0 : (_metricValues$filter = metricValues.filter(function (val) {
        return val.period.includes(props.reportingPeriodType === MetricReportingPeriodType.Quarterly ? 'Q' : 'M');
      })) === null || _metricValues$filter === void 0 ? void 0 : _metricValues$filter.sort(function (a, b) {
        if (props.reportingPeriodType === MetricReportingPeriodType.Monthly) {
          return parseInt(a.period.split('M')[1]) - parseInt(b.period.split('M')[1]);
        }
        return a.period.localeCompare(b.period);
      })) || [];
    };
    var filteredMetricValues = ref(filterForReportingPeriodTypeAndSort(props.metricValues));
    var allPeriods = computed(function () {
      var periods = [];
      if (props.reportingPeriodType === MetricReportingPeriodType.Quarterly) {
        // Generate Q1-Q4
        for (var i = 1; i <= 4; i++) {
          periods.push("".concat(props.year, " Q").concat(i));
        }
      } else if (props.reportingPeriodType === MetricReportingPeriodType.Monthly) {
        // Generate M1-M12
        for (var _i = 1; _i <= 12; _i++) {
          periods.push("".concat(props.year, " M").concat(_i));
        }
      }
      return periods;
    });
    var allMetricValues = computed(function () {
      var existingValues = new Map(filteredMetricValues.value.map(function (val) {
        return [val.period, val];
      }));
      return allPeriods.value.map(function (period) {
        var existingValue = existingValues.get(period);
        if (existingValue) {
          return existingValue;
        }
        return {
          metricAssignmentId: props.metricAssignmentId,
          period: period,
          actual: null,
          target: null,
          text: null,
          options: null,
          skipped: false,
          editable: true,
          isConditionMet: true,
          type: props.metric.valueType
        };
      });
    });
    var onInput = function onInput(vals) {
      var newInputs = _toConsumableArray(props.inputs);
      var _iterator = _createForOfIteratorHelper(vals),
        _step;
      try {
        var _loop = function _loop() {
          var val = _step.value;
          // When ever the users make a change, we store it in the local state so cancelling the MetricValueDialog properly resets the form
          filteredMetricValues.value = filteredMetricValues.value.map(function (item) {
            return item.metricAssignmentId === val.metricAssignmentId && item.period === val.period ? _objectSpread(_objectSpread({}, item), val) : item;
          });

          // update inputs
          var index = newInputs.findIndex(function (i) {
            return i.metricAssignmentId === val.metricAssignmentId && i.period === val.period;
          });
          var toAdd;
          if (index > -1) {
            toAdd = _objectSpread(_objectSpread({}, newInputs[index]), val);
            newInputs.splice(index, 1); // remove the obj the value
          } else {
            toAdd = val;
          }
          newInputs.push(toAdd);
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      context.emit('input', newInputs);
    };
    var periodToLabel = function periodToLabel(period) {
      return {
        '1': 'Jan',
        '2': 'Feb',
        '3': 'Mar',
        '4': 'Apr',
        '5': 'May',
        '6': 'Jun',
        '7': 'Jul',
        '8': 'Aug',
        '9': 'Sep',
        '10': 'Otc',
        '11': 'Nov',
        '12': 'Dec'
      }[period.split('M')[1]];
    };
    var disabled = computed(function () {
      return props.skipped;
    });
    return {
      onInput: onInput,
      MetricReportingPeriodType: MetricReportingPeriodType,
      filteredMetricValues: filteredMetricValues,
      periodToLabel: periodToLabel,
      disabled: disabled,
      allMetricValues: allMetricValues
    };
  }
});